import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSuccessNotification } from '../services/common';
import { setHomePageLinkGroups } from '../services/misc';

// eslint-disable-next-line import/prefer-default-export
export const useUpdateHomePageLinkGroup = () => {
  const queryClient = useQueryClient();
  return useMutation(
    data => {
      const cleanedData = data.map((item, index) => {
        return {
          ...item,
          id: Number.isNaN(Number(item.id)) ? undefined : item.id,
          ordering: index + 1,
          homePageLinks: item.homePageLinks.map((link, linkIndex) => ({
            ...link,
            ordering: linkIndex + 1,
            id: Number.isNaN(Number(link.id)) ? undefined : link.id,
          })),
        };
      });
      return setHomePageLinkGroups(cleanedData);
    },
    {
      onSuccess: async () => {
        showSuccessNotification(`Update home page link successfully`);
        queryClient.invalidateQueries(['homePageLinkGroups']).then(() => {});
      },
    },
  );
};
